export default __webpack_public_path__ + "e7c4ad9943c54f5c3355e29945d592c2.glb";